import { Pipe, PipeTransform } from '@angular/core';
import { defaultTo } from 'lodash';
import { IhmSystemStatusView } from '../../../components/ihm-system-status/ihm-system-status-view.enum';

@Pipe({ name: 'ihmSystemStatus' })
export class IhmSystemStatusPipe implements PipeTransform {
  private readonly ICON_MAP: Map<IhmSystemStatusView, string> = new Map([
    [IhmSystemStatusView.IN_BUILD, 'build'],
    [IhmSystemStatusView.IN_PROGRESS, 'build'],
    [IhmSystemStatusView.REVISING_ORDER, 'restore'],
    [IhmSystemStatusView.DRAFT, 'build'],

    [IhmSystemStatusView.APPROVED, 'done'],
    [IhmSystemStatusView.COMPLETE, 'done'],
    [IhmSystemStatusView.ORDER_IN_FLIGHT, 'flight'],
    [IhmSystemStatusView.APPROVED_MANUAL_INJECTED, 'done'],
    [IhmSystemStatusView.APPROVED_AUTO_INJECTED, 'done'],

    [IhmSystemStatusView.MANUAL_INJECTION, 'keyboard'],
    [IhmSystemStatusView.READ_ONLY, 'remove_red_eye'],
    [IhmSystemStatusView.ASSIGNED, 'assignment_ind'],

    [IhmSystemStatusView.PENDING_APPROVAL, 'timer'],
    [IhmSystemStatusView.PENDING_MANUAL_INJECTION, 'timer'],
    [IhmSystemStatusView.SUBMITTED, 'timer'],
    [IhmSystemStatusView.SYNCING, 'timer'],
    [IhmSystemStatusView.UNDER_REVIEW, 'timer'],

    [IhmSystemStatusView.PARTIAL_UPDATED, 'warning'],
    [IhmSystemStatusView.ESCALATED, 'warning'],
    [IhmSystemStatusView.NEED_MORE_INFO, 'info'],

    [IhmSystemStatusView.REJECTED, 'close'],
    [IhmSystemStatusView.FAILED, 'close'],
    [IhmSystemStatusView.CANCELLED, 'horizontal_rule']
  ]);

  private readonly COLOR_MAP: Map<IhmSystemStatusView, string> = new Map([
    [IhmSystemStatusView.IN_BUILD, '#823E8D'],
    [IhmSystemStatusView.IN_PROGRESS, '#823E8D'],
    [IhmSystemStatusView.REVISING_ORDER, '#823E8D'],
    [IhmSystemStatusView.DRAFT, '#823E8D'],

    [IhmSystemStatusView.APPROVED, '#03AB49'],
    [IhmSystemStatusView.COMPLETE, '#03AB49'],
    [IhmSystemStatusView.ORDER_IN_FLIGHT, '#03AB49'],
    [IhmSystemStatusView.APPROVED_MANUAL_INJECTED, '#03AB49'],
    [IhmSystemStatusView.APPROVED_AUTO_INJECTED, '#03AB49'],

    [IhmSystemStatusView.MANUAL_INJECTION, '#717277'],
    [IhmSystemStatusView.READ_ONLY, '#717277'],
    [IhmSystemStatusView.ASSIGNED, '#717277'],

    [IhmSystemStatusView.PENDING_APPROVAL, '#E8C205'],
    [IhmSystemStatusView.PENDING_MANUAL_INJECTION, '#E8C205'],
    [IhmSystemStatusView.SUBMITTED, '#E8C205'],
    [IhmSystemStatusView.SYNCING, '#E8C205'],
    [IhmSystemStatusView.UNDER_REVIEW, '#E8C205'],

    [IhmSystemStatusView.PARTIAL_UPDATED, '#E86317'],
    [IhmSystemStatusView.ESCALATED, '#E86317'],
    [IhmSystemStatusView.NEED_MORE_INFO, '#E86317'],

    [IhmSystemStatusView.REJECTED, '#E22100'],
    [IhmSystemStatusView.FAILED, '#E22100'],
    [IhmSystemStatusView.CANCELLED, '#E22100']
  ]);

  private readonly TEXT_MAP: Map<IhmSystemStatusView, string> = new Map([
    [IhmSystemStatusView.IN_BUILD, 'In Build'],
    [IhmSystemStatusView.IN_PROGRESS, 'In Progress'],
    [IhmSystemStatusView.REVISING_ORDER, 'Revising Order'],
    [IhmSystemStatusView.DRAFT, 'Draft'],

    [IhmSystemStatusView.APPROVED, 'Approved'],
    [IhmSystemStatusView.COMPLETE, 'Complete'],
    [IhmSystemStatusView.ORDER_IN_FLIGHT, 'Order In Flight'],
    [IhmSystemStatusView.APPROVED_MANUAL_INJECTED, 'Approved/ Manual Injection'],
    [IhmSystemStatusView.APPROVED_AUTO_INJECTED, 'Approved/&nbsp;&nbsp;&nbsp;   Auto Injection'],

    [IhmSystemStatusView.MANUAL_INJECTION, 'Manual Injection'],
    [IhmSystemStatusView.READ_ONLY, 'Read Only'],
    [IhmSystemStatusView.ASSIGNED, 'Assigned'],

    [IhmSystemStatusView.PENDING_APPROVAL, 'Pending Approval'],
    [IhmSystemStatusView.PENDING_MANUAL_INJECTION, 'Pending Manual Injection'],
    [IhmSystemStatusView.SUBMITTED, 'Submitted'],
    [IhmSystemStatusView.SYNCING, 'Syncing'],
    [IhmSystemStatusView.UNDER_REVIEW, 'Under Review'],

    [IhmSystemStatusView.PARTIAL_UPDATED, 'Partial Update'],
    [IhmSystemStatusView.ESCALATED, 'Escalated'],
    [IhmSystemStatusView.NEED_MORE_INFO, 'Need more Info'],

    [IhmSystemStatusView.REJECTED, 'Rejected'],
    [IhmSystemStatusView.FAILED, 'Failed'],
    [IhmSystemStatusView.CANCELLED, 'Cancelled']
  ]);

  transform(data: string, type: string): string {
    const statusView: IhmSystemStatusView = this.getSystemStatus(data);
    const proposalIcon: string = this.getSystemStatusViewByType(statusView, type);
    return proposalIcon || '';
  }

  private getSystemStatus(data: string): IhmSystemStatusView {
    const systemStatus: string = defaultTo(data, '');
    return IhmSystemStatusView[systemStatus.toUpperCase()];
  }

  private getSystemStatusViewByType(statusView: IhmSystemStatusView, type: string): string {
    switch (type) {
      case 'icon':
        return this.getSystemStatusViewIcon(statusView);
      case 'color':
        return this.getSystemStatusViewColor(statusView);
      default:
        return this.getSystemStatusViewText(statusView);
    }
  }

  private getSystemStatusViewText(systemStatusView: IhmSystemStatusView): string {
    return this.TEXT_MAP.get(systemStatusView);
  }

  private getSystemStatusViewIcon(systemStatusView: IhmSystemStatusView): string {
    return this.ICON_MAP.get(systemStatusView);
  }

  private getSystemStatusViewColor(systemStatusView: IhmSystemStatusView): string {
    return this.COLOR_MAP.get(systemStatusView);
  }
}
